<template>
  <div>
    <div class="clock">
      <div class="time">{{ formattedTime }}</div>
      <div class="date">{{ formattedDate }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['time']),
    formattedDate() {
      return moment(this.time).format('DD.MM.YYYY');
    },
    formattedTime() {
      return moment(this.time).format('HH:mm');
    },
  },
};
</script>

<style scoped>
.time {
  text-align: center;
  font-weight: bold;
  font-size: 80pt;
  margin-bottom: 2%;
}
.date {
  text-align: center;
  font-size: 36pt;
}
</style>
